import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';


import '../BXmakerAuthuseremailInput';

Vue.component('BXmakerAuthuseremailLoginRegistrationFields',
    {
        data: function () {
            return {

            };
        },
        computed: {
            ...Vuex.mapState('bxmaker/authuseremail/login', [
                'expandFields',
            ]),
            localize()
            {
                return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSEREMAIL_');
            }
        },
        methods: {
            resetExpandFields(){
                this.$store.commit('bxmaker/authuseremail/login/resetExpandField');
            },
            setExpandField(name, value){
                this.$store.commit('bxmaker/authuseremail/login/setExpandField', { [name]: value });
            }
        },
        template: `
            <template />
        `,
    });